export enum MonthEnum {
  FARVARDIN = 0,
  ORDIBEHESHT = 1,
  KHORDAD = 2,
  TIR = 3,
  MORDAD = 4,
  SHAHRIVAR = 5,
  MEHR = 6,
  ABAN = 7,
  AZAR = 8,
  DEY = 9,
  BAHMAN = 10,
  ESFAND = 11,
}
